import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomDialogComponent } from '../../../component/custom-dialog/custom-dialog.component';
import { ServiceProviderService } from '../../../Service/Service-providers/service-provider.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewerComponent } from '../../../component/viewer/viewer.component';
import { FormStateService } from '../add-sp-new-component/form-state.service';
import { Location } from '@angular/common';
import { ToastService } from '../../../Service/ToastService/toast.service';

interface EventItem {
  status?: string;
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
}

@Component({
  selector: 'app-service-providers-details-2',
  templateUrl: './service-providers-details-2.component.html',
  styleUrl: './service-providers-details-2.component.scss',
})
export class ServiceProvidersDetails2Component implements OnInit {
  serviceProviderName = '';
  imgPath = '';
  emailAddress = '';
  address = '';
  name = '';
  contact = '';
  status = '';
  businessType = '';
  submittedBy = '';
  email = '';
  gst = '';
  date = '';
  commencementYear = '';
  applicationId = '';
  planName = 'Basic';
  paidAmount = '₹299/-';
  serviceName: any;
  serviceProviderId: any;
  serviceprovider: any;
  userName = '';
  garageInChargeName = '';
  serviceProviderTechnicians: any = [];
  serviceProviderDocuments: any[] = [];
  selectedDocumentUrl: any | undefined;
  visible = false;
  visibleReject = false;
  visibleViewer = false;
  showDocumentViewer = false;
  garageInChargePhoneNumber = '';
  ownerEmailAddress = '';
  ownerPhoneNumber = '';
  applicantEmailAddress = '';
  showModal = false;
  idToEdit!: any;
  data: any;

  events: any;
  showAllServices: boolean = false;
  visibleHistory: boolean = false;
  visibleDelete: boolean = false;
  reviewModal = false;
  accessType: number = 0;
  @Output() onFinish = new EventEmitter<void>();
      @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private api: ServiceProviderService,
    private formStateService: FormStateService,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private router: Router,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.accessType = user?.accessType;
    console.log('Accesstype::::', this.accessType)
    this.route.paramMap.subscribe((params) => {
      this.serviceProviderId = params.get('serviceProviderId');
      this.formStateService.setServiceProviderId(this.serviceProviderId);
      this.formStateService.setUserId(this.serviceProviderId);
      this.getServiceProvidersDetails();
      // Check if route includes edit
      if (this.router.url.includes('/edit-service-provider')) {
        this.openEditModal(this.serviceProviderId);
      }
    });
    this.route.url.subscribe((urlSegments) => {
      const isEditMode = urlSegments.some(segment => segment.path === 'edit-service-provider');
      if (isEditMode) {

        this.openEditModal(this.serviceProviderId);
      }
    });
  }
  refreshDetails() {
    this.closeApproveModal();
    this.getServiceProvidersDetails();
  }
  getServiceProviderDetailsById() {
    this.closeRejectModal();
    this.getServiceProvidersDetails();
  }
  getServiceProvidersDetails() {
    this.api
      .getServiceproviderById(this.serviceProviderId)
      .subscribe((res: any) => {
        this.cdr.detectChanges();
        this.serviceprovider = res;
        this.serviceProviderName = res.name;
        this.formStateService.setSubDomainName(this.serviceProviderName.toLowerCase().replace(/\s+/g, ''));
        this.address = res.address;
        this.applicationId = res.applicationNumber;
        this.submittedBy = res.applicantName;
        this.gst = res.gstNumber || 'Not provided';
        this.commencementYear = res.yearOfEstablishment;
        this.contact = res.phoneNumber;
        this.emailAddress = res.ownerEmailAddress || 'Not available';
        this.status = res.status;
        this.serviceName = res.serviceOffers.map((x: any) => x.serviceName);
        this.userName =
          res.ownerEmailAddress + '....' || 'No Email Address provided';
        this.name = res.ownerName || res.sponsorName;
        this.businessType = res.businessType.name;
        this.garageInChargeName = res.garageInChargeName;
        this.garageInChargePhoneNumber = res.garageInChargePhoneNumber;
        this.ownerPhoneNumber = res.ownerPhoneNumber || res.sponsorPhoneNumber;
        this.applicantEmailAddress = res.applicantEmailAddress;
        this.date = res.createdDate;
        this.serviceProviderDocuments = res.serviceProviderDocuments;
        this.ownerEmailAddress =
          res.ownerEmailAddress || res.sponorEmailAddress;

        const filePath =
          res.serviceProviderGalleries.length > 0
            ? res.serviceProviderGalleries[0].filePath
            : '';
        this.imgPath = `${filePath}`;
        console.log('Image-path:', JSON.stringify(this.imgPath))

        this.serviceProviderTechnicians = res.serviceProviderTechnicians.map(
          (technician: any) => {
            return {
              technicianId: technician.technicianId,
              technicianName: technician.technicianName,
              noOfTechnician: technician.noOfTechnician,
            };
          }
        );

        console.log(this.serviceprovider);
      });
  }

  getTotalTechnicians(): number {
    if (
      this.serviceprovider &&
      this.serviceprovider.serviceProviderTechnicians
    ) {
      return this.serviceprovider.serviceProviderTechnicians
        .map((tech: any) => tech.noOfTechnician)
        .reduce((total: number, num: number) => total + num, 0);
    }
    return 0;
  }

  get truncatedEmail(): string {
    const maxLength = 6;
    if (this.applicantEmailAddress.length > maxLength) {
      return this.applicantEmailAddress.substring(0, maxLength) + '.....';
    } else {
      return this.applicantEmailAddress;
    }
  }

  subDomainName() {
    // set sub-domain name
    const subDomainName = this.serviceProviderName!.toLowerCase().replace(
      /\s+/g,
      ''
    );
    this.formStateService.setSubDomainName(subDomainName);
    return subDomainName;
  }

  get truncatedServiceProviderName(): string {
    const maxLength = 50;
    if (this.serviceProviderName.length > maxLength) {
      return this.serviceProviderName.substring(0, maxLength) + '....';
    } else {
      return this.serviceProviderName;
    }
  }
  viewAddressProof() {
    const addressProofDocument = this.serviceProviderDocuments.find(
      (doc) => doc.documentTypeId === 5
    );
    console.log('Selected Document URL 5:', addressProofDocument);
    this.openViewer(addressProofDocument.filePath)
  }

  viewOwnerIdProof() {
    const ownerIdProofDocument = this.serviceProviderDocuments.find(
      (doc) => doc.documentTypeId === 7
    );
    console.log('Doc is 7:', ownerIdProofDocument.filePath)
    this.openViewer(ownerIdProofDocument.filePath)
  }

  viewInchargeIdProof() {
    const inchargeIdProofDocument = this.serviceProviderDocuments.find(
      (doc) => doc.documentTypeId === 8
    );
    if (inchargeIdProofDocument) {
      this.selectedDocumentUrl = `${inchargeIdProofDocument.filePath}`;
      this.showDocumentViewer = true;
      this.visibleViewer = true;
    } else {
      console.error('Incharge ID proof document with documentTypeId 8 not found.');
    }
  }


  viewCOIProof() {
    const coiProofDocument = this.serviceProviderDocuments.find(
      (doc) => doc.documentTypeId === 6
    );
    if (coiProofDocument) {
      this.selectedDocumentUrl = `${coiProofDocument.filePath}`;
      this.showDocumentViewer = true;
      console.log('Selected Document URL:', this.selectedDocumentUrl);
      this.visibleViewer = true; // Ensure the modal is visible
    } else {
      console.error(
        'Certificate of Incorporation proof document with documentTypeId 6 not found.'
      );
    }
  }

  closeViewer() {
    this.visibleViewer = false;
    this.selectedDocumentUrl = undefined; // Clear the document URL when the viewer is closed
    this.showDocumentViewer = false;
  }

  approve() {
    console.log('Approve button is clicked');
    this.visible = true;
    console.log('domain',this.subDomainName());
  }
  viewer() {
    this.visibleViewer = true;
  }

  showModalW() {
    this.showModal = false;
    this.getServiceProvidersDetails();
  }
  openEditModal(id: any) {
    this.idToEdit = id;
    console.log(this.idToEdit);
    setTimeout(() => {
      this.showModal = true;
      this.router.navigate(['edit-service-provider'], { relativeTo: this.route });
    });
  }

  reject() {
    this.visibleReject = true;
  }

  closeApproveModal(): void {
    this.formStateService.setSubDomainName(''); 
    this.visible = false;
  }

  closeRejectModal(): void {
    this.visibleReject = false;
  }

   showDeleteDialog() {
    this.visibleDelete = true;
  }

  delete() {
  this.visibleDelete = false;

  if (!this.serviceProviderId ) {
    console.error('Distributor ID is missing');
    this.toastService.showToast('Distributor ID not found.','error');
    return;
  }

  this.api.deleteServiceProvider(this.serviceProviderId ).subscribe({
    next: (res) => {
      if (res.isSuccess) {
        this.toastService.showToast(res.result || 'Distributor deleted successfully.', 'success');
        this.close.emit();
        this.onFinish.emit();
        this.location.back();
        this.router.navigate(['vehicle-service-provider']);

      } else {
        this.toastService.showToast('Failed to delete distributor.', 'error');
      }
    },
    error: (err) => {
      console.error('Error deleting distributor:', err);
      this.toastService.showToast('Something went wrong while deleting the distributor.', 'error');
    }
  });
}
  displayHistory() {
    this.visibleHistory = true;
    this.api.getHistory(this.serviceProviderId).subscribe((data: any) => {
      console.log(data);
      this.events = data;
    });
  }

  // Getter to determine which services to display based on the showAllServices flag
  get displayedServices(): string[] {
    return this.showAllServices
      ? this.serviceName
      : this.serviceName?.slice(0, 4);
  }

  toggleShowAllServices() {
    this.showAllServices = !this.showAllServices;
  }
  openReviewModal() {
    this.reviewModal = true;
  }
  closeReviewModal() {
    this.reviewModal = false;
  }
  markForReview() {
    this.reviewModal = false;
  }
  goBack() {
    this.location.back();
  }
  openViewer(url: string) {
    console.log('Opening viewer with URL:', url);
    this.selectedDocumentUrl = url;
    this.visibleViewer = true;
  }

  downloadImage() {
    if (!this.selectedDocumentUrl) return;

    const link = document.createElement('a');
    link.href = this.selectedDocumentUrl;
    link.download = this.getFileNameFromUrl(this.selectedDocumentUrl);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getFileNameFromUrl(url: string): string {
    // Extract filename from URL
    const matches = url.match(/\/([^\/?#]+)[^\/]*$/);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    return 'document_' + new Date().getTime() + (this.isPdf(url) ? '.pdf' : '.jpg');
  }

  isPdf(url: string | undefined): boolean {
    if (!url) return false;
    // Check for PDF extension or content type
    const cleanUrl = url.split('?')[0].toLowerCase();
    return cleanUrl.endsWith('.pdf') ||
      (url.includes('content-type') && url.includes('application/pdf'));
  }
}
